module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0163.jpg?v=6fda8976";